import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ListIcon from '@mui/icons-material/List';
import React, { memo } from 'react';


export const TypeCell = memo(({ row }) => (row.isUserListQuestion
  ? <ListIcon /> : <AutoGraphIcon />));

TypeCell.displayName = 'TypeCell';
